import DocumentPage from "components/documents/DocumentPage";

export default () => {
  return <DocumentPage isMemberDocument={false} showFullActions={true} />;
};
